import Reflux from "reflux";

export default {
    chatsStatuses: Reflux.createAction({ sync: false }),
};
